// extracted by mini-css-extract-plugin
module.exports = {"el":"CountingNumbers_el__Sgp_B","visible":"CountingNumbers_visible__ucMd2"};